// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'

import icons from '@/iconify/index.json'
import { initAliyunDeviceRisk } from '@/utils/aliyunDeviceRisk'
import { setupAppVersionChecker } from '@/utils/appVersion'

// 自定义指令
import directive from '@/utils/directive'
import VxeUIPluginExportXLSX from '@vxe-ui/plugin-export-xlsx'
import ExcelJS from 'exceljs'

import VxeUIBase, { VxeUI } from 'vxe-pc-ui'
import VxeUITable from 'vxe-table'
import App from './App.vue'
import i18n from './locales'
import router from './router'
import pinia from './store'

import uiProvider from './ui/provider'
import '@/utils/systemCopyright'

// 加载 svg 图标
import 'virtual:svg-icons-register'
import 'virtual:uno.css'
import '@unocss/reset/tailwind-compat.css'
// 全局样式
import '@/assets/styles/globals.css'
// vxe-table 样式
import 'vxe-table/lib/style.css'
import 'vxe-pc-ui/lib/style.css'
// 暗黑模式样式
import '@/assets/styles/dark.scss'
// 移动端暗黑模式样式
import '@/assets/styles/dark-mobile.scss'
// 引入 TDesign 组件库的少量全局样式变量
import 'tdesign-mobile-vue/es/style/index.css'

VxeUI.use(VxeUIPluginExportXLSX, {
  ExcelJS,
})
// 全局配置 vxe-table 最大冻结列数为 10
VxeUI.setConfig({
  table: {
    columnConfig: {
      maxFixedSize: 10,
    },
  },
})

void initAliyunDeviceRisk()

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(i18n)
app.use(VxeUIBase).use(VxeUITable)
directive(app)
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}
app.mount('#app')
setupAppVersionChecker(router)

const userStore = useUserStore()
window.addEventListener('storage', (e) => {
  if (e.key === 'token' && !e.newValue) {
    userStore.token = ''
  }
})
